import styled from "styled-components";
import { Gray, Blue, White } from '../../../../colors';
import { Barlow, Gilroy } from '../../../font';
export const StepContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 80%;
  max-width: 290px;
  margin: auto;
`;
export const Row = styled.div `
  display: flex;
  flex-direction: row;
  margin-bottom: 7px;
`;
export const ColumnLeft = styled.div `
  width: 30px;
  padding-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const VerticalDottedLine = styled.div `
  position: relative;
  width: auto;
  height: auto;
  right: -3px;
  bottom: 0px;
  padding: 5px 0;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  color: ${Blue[2]};
  font-size: 12px;
`;
export const ColumnRight = styled.div `
  width: auto;
  padding-left: 5px;
  text-align: left;
`;
export const StepTitle = styled(Gilroy) `
  display: block;
  padding-left: 7px;
  font-weight: bold; 
  font-style: normal;
  font-size: 1rem;
  padding-bottom: 2px;

  img {
      padding-right: 5px;
      width: 22px;
      vertical-align: middle;
  }
`;
export const StepFooter = styled(Barlow) `
  display: block;
  color: ${Gray.obscure};
  font-weight: 500;
  font-style: normal;
  font-size: 0.9rem;
  padding-left: 7px;
`;
export const DigitBackground = styled.div `
  & {
    background-color: ${Blue[2]};
    margin: 0 auto;
    position: relative;
    width: 9px;
    height: 23px;
    border-radius: 10px;
  }
  &:before {
    width: 9px;
    height: 23px;
    background-color: ${Blue[2]};
    border-radius: 10px;
    content: "";
    display: block;
    position: absolute;
    transform: rotate(60deg);
  }
  &:after {
    width: 9px;
    height: 23px;
    background-color: ${Blue[2]};
    border-radius: 10px;
    content: "";
    display: block;
    transform: rotate(-60deg);
  }
`;
export const Digit = styled(Gilroy) `
  font-weight: bold; 
  font-style: normal;
  font-size: 0.95rem;
  color: ${White.normal};
  position: absolute;
  top: 2px;
  right: 0;
`;
//# sourceMappingURL=step-rows.styled.js.map